<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>
<div id="modal-electronic-purpose">
    <div class="modal-header">
        <h4 id="consent-title" class="modal-title">{{ ('signatureProcessDetails.popup.title' | translate).toUpperCase() }}</h4>
    </div>
    <div class="modal-body">
        <div *ngIf="personalDataConsent.consentMessage">
            <pre class="consent-text" id="consent-text">{{personalDataConsent.consentMessage}}</pre>
        </div>

        <div *ngIf="personalDataConsent.extReference">
            <p class="consent-text" id="consent-ext-ref">{{personalDataConsent.extReference}}</p>
        </div>

        <div *ngIf="personalDataConsent.links">
            <h5 id="consent-more-info">{{'signatureProcessDetails.popup.links' | translate}}</h5>
            <ul class="links-list">
                <li *ngFor="let link of personalDataConsent.links; let index = index">
                    <a href="{{link.link}}" id="consent-link-{{index}}">{{link.label ? link.label : link.link}}</a>
                </li>
            </ul>
        </div>
    </div>
    <div class="modal-footer">
        <button class="certificateClose" id="modal-electronic-close" (click)="activeModal.dismiss()">{{'close' | translate}}</button>
    </div>
</div>
